<template>
  <div class="delta-widget-cell">
    <div v-if="!hideTitle" class="delta-widget-cell__title">{{this.$t(title)}}</div>
    <div class="delta-widget-cell__data" :class="{'high-delta': value > 0, 'low-delta': value < 0 }">
      {{getFormattedData}}
      <v-icon v-if="value!==0 && trend">{{ value > 0 ? 'trending_up': 'trending_down' }}</v-icon>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DeltaWidgetCell',
  props: {
    value: {
      type: Number,
      required: true,
    },
    trend: {
      type: Boolean,
      required: false,
      default: true,
    },
    hideTitle: {
      type: Boolean,
      required: false,
      default: false,
    },
    title: {
      type: String,
      required: false,
      default: 'dashboard.delta.widget.title',
    },
    noData: {
      required: false,
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getFormattedData() {
      if (this.noData) {
        return this.$t('no.data.dashboard.stats');
      }
      if (!this.trend) {
        return this.value;
      }
      if (this.value === 0) {
        return 0;
      }
      if (this.value > 0) {
        return `+${this.value}%`;
      }
      return `${this.value}%`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/design-system";

.delta-widget-cell {
  display: flex;
  flex-direction: column;
  min-width: rem(125);
  margin-right: $space-6;

  &__title {
    font-family: $font-family-regular;
    font-size: $font-size-sm;
    padding-bottom: $space-1;
    letter-spacing: $letter-spacing-normal;
    line-height: $line-height-snug;
    color: var(--text-primary);
  }

  &__data {
    font-family: $font-family-semibold;
    font-size: $font-size-3xl;
    font-weight: 600;
    letter-spacing: $letter-spacing-normal;
    line-height: $line-height-tight;
    color: var(--text-secondary);
    background-color: $delta-no-change-bg;
    text-align: center;
    width: fit-content;
    padding-left: $space-2;
    padding-right: $space-2;
    border-radius: $radius-md;

    &.high-delta {
      color: var(--widget-delta-high-text);
      background-color: var(--widget-delta-high-bg);

      .v-icon {
        color: var(--widget-delta-high-text);
        margin-left: -$space-2;
      }
    }

    &.low-delta {
      color: var(--widget-delta-low-text);
      background-color: var(--widget-delta-low-bg);

      .v-icon {
        color: var(--widget-delta-low-text);
        margin-left: -$space-2;
      }
    }
  }
}
</style>
